'use client';

import React from 'react';
import HeroSection from '@/components/landing/HeroSection';
import ProblemSection from '@/components/landing/ProblemSection';
import ComparisonSection from '@/components/landing/ComparisonSection';
import FeaturesSection from '@/components/landing/FeaturesSection';
import PricingSection from '@/components/landing/PricingSection2';
import Footer from '@/components/layout/Footer';
import NavigationBar from '@/components/layout/NavigationBar';
import UseCasesSection from '@/components/landing/UseCasesSection';
import { useSmoothScroll } from '@/hooks/useSmoothScroll';
import OfferSection from '@/components/landing/OfferSection';
import FaqSection from '@/components/landing/FaqSection';
import TrustSection from '@/components/landing/TrustSection';
import SolutionSection from '@/components/landing/SolutionSection';
import AIProblemSection from '@/components/landing/AIProblemSection';
import StatementSection from '@/components/landing/StatementSection';

export default function HomePage() {
  useSmoothScroll();

  return (
    <div className="min-h-screen overflow-x-hidden">
      <NavigationBar />
      <main className="flex min-h-screen flex-col left-0 right-0">
        <HeroSection />
        <TrustSection />
        <ProblemSection />
        <SolutionSection />
        <UseCasesSection />
        <FeaturesSection />
        <PricingSection />
        <ComparisonSection />
        <AIProblemSection />
        <StatementSection />
        <OfferSection />
        <FaqSection />
        <Footer />
      </main>
    </div>
  );
}

// Optional: Add CSS for fade-in animation if needed (e.g., in globals.css)
/*
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fadeIn 0.5s ease-out forwards;
}
*/
